import React from "react";

import { ORGANIZATION_TYPES } from "utils/organization/constants";

import Select from "components/Input/Select";
import Button from "components/Button";

import classes from "../style.module.scss";

const TypeStep = ({ name, orgType, setOrgType, onBack, onContinue }) => (
    <>
        <p>What kind of organization is {name}? Select the most appropriate option.</p>
        <Select
            label="Organization Type"
            placeholder="Select a type"
            options={ORGANIZATION_TYPES}
            input={{ value: orgType, onChange: setOrgType }}
        />
        <div className={classes.footer}>
            <Button onClick={onBack} type="hollow">
                Back
            </Button>
            <Button onClick={onContinue} disabled={!orgType}>
                Continue
            </Button>
        </div>
    </>
);

export default TypeStep;
